import { ErrorHandler, NgModule } from "@angular/core";
import { ApplicationinsightsAngularpluginErrorService } from "@microsoft/applicationinsights-angularplugin-js";
import { Insights } from "./services/insights.service";
import { InsightsApiService } from "./services/insights-api.service";

@NgModule({
    providers: [
        Insights,
        {
            provide: ErrorHandler,
            useClass: ApplicationinsightsAngularpluginErrorService
        }
    ]
})

/**
 * Grouping all of the insights related pieces into one place, InsightsModule.
 */
export class InsightsModule {
    constructor(private insights: Insights, private insightsApi: InsightsApiService){}
}